module.exports = __webpack_public_path__ + "static/img/icon_subway_current.aca9f09c.png";